import { Controller } from "stimulus"
import moment from 'moment'

export default class extends Controller {
	static targets = ["time"]

  connect(){
    this.localizeServerTime()
  }
	localizeServerTime(){
		const targets = this.timeTargets
		const inputDateFormat = 'YYYY-MM-DD HH:mm:ss z'; // input date format (should be in UTC)
		const outputDateFormat = 'MMM Do, YYYY [at] h:mm A'; // default output date format
		const todayFormat = '[Today] [at] LT'
		const yesterdayFormat = '[Yesterday] [at] LT'
		const nextDayFormat = '[Tomorrow] [at] LT'


		targets.forEach((element) => {
			const serverTime = element.dataset.serverTimeValue || element.textContent
			if (!serverTime) { return }

			const parsed = moment.utc(serverTime, inputDateFormat)
			if (!parsed.isValid()) { return }

			const displayMode = element.dataset.localizeServerTimeDisplayMode || 'calendar'
			const localTime = parsed.local()

			if (displayMode === 'format') {
				const displayFormat = element.dataset.localizeServerTimeDisplayFormat || outputDateFormat
				element.textContent = localTime.format(displayFormat)
			} else {
				element.textContent = localTime.calendar(null, {
					sameDay: todayFormat,
					lastDay: yesterdayFormat,
					nextDay: nextDayFormat,
					lastWeek: outputDateFormat,
					sameElse: outputDateFormat
				})
			}
		})
	}
}
